<template>
  <v-app id="app">
    <v-snackbar
      :value="showedSnackBar"
      :timeout="5000"
      top
      right
      @input="changeSnackbar"
    >
      {{ snackbarText }}
      <v-btn dark text icon @click="hideSnackBar()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-app-bar
      v-if="isLoggedIn && withTabs"
      id="principal-header"
      app
      flat
      height="35"
      color="primary darken-4"
      dark
    >
      <v-toolbar-title v-if="isMobile" to="/" class="mr-6 pl-2">
        <router-link to="/" tag="span" class="pointer">
          Ag
        </router-link>
      </v-toolbar-title>
      <v-toolbar-title v-else to="/" class="mr-6 pl-2">
        <router-link to="/" tag="span" class="pointer">
          AgroGesttion
        </router-link>
      </v-toolbar-title>

      <v-toolbar-items v-if="!isMobile">
        <div v-for="item in items" :key="item.title">
          <v-btn
            v-if="item.display != false && hasPermission(item.ability)"
            text
            active-class="active-tab"
            :to="{ path: item.to, query: queryString }"
            link
            @click="itemSelected = item"
          >
            {{ item.title }}
          </v-btn>
        </div>
      </v-toolbar-items>

      <v-toolbar-items v-else>
        <v-menu offset-y bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="white" text v-on="on">
              {{ itemSelected ? itemSelected.title : null }}
              <v-icon>arrow_drop_down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <div v-for="(item, index) in items" :key="index">
              <v-list-item
                v-if="hasPermission(item.ability)"
                :to="item.to"
                @click="itemSelected = item"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </div>
          </v-list>
        </v-menu>
      </v-toolbar-items>

      <v-spacer />

      <v-chip v-show="isTest" class="mx-2 font-weight-bold" small color="red">
        en test
      </v-chip>

      <div v-if="empresas.length > 1">
        <v-autocomplete
          v-if="isLoggedIn && !isMobile"
          :value="empresaSelected"
          return-object
          placeholder="Empresa"
          item-text="nombre"
          :loading="empresasLoading"
          :items="empresas"
          :search-input.sync="searchEmpresaInput"
          hide-no-data
          hide-details
          auto-select-first
          dense
          tile
          single-line
          @input="setEmpresaSelected"
        />
      </div>

      <div v-else v-show="!isMobile" class="overline">
        {{ empresaSelected ? empresaSelected.nombre : null }}
      </div>

      <v-btn
        v-show="!isMobile"
        v-if="hasPermission('config_edit')"
        text
        icon
        small
        dark
        color="white"
        :to="{ path: '/crud', query: queryString }"
        class="ml-5 mr-2"
      >
        <v-icon>build</v-icon>
      </v-btn>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="white"
            icon
            dark
            v-bind="attrs"
            v-on="on"
          >
          <v-icon>info</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title class="text-subtitle-2">
                Fechas última tarja, por campo
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-for="(campo, index) in campos"
            :key="index"
          >
            <v-list-item-title>
              {{ campo.nombre }}
              </v-list-item-title>
            <v-list-item-subtitle>
              {{ campo.fecha_ultima_tarja | formatDate}}
            </v-list-item-subtitle>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu offset-y transition="slide-x-transition">
        <template v-slot:activator="{ on }">
          <v-btn class="mx-2" color="white" dark icon text small v-on="on">
            <v-icon>person</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title>{{ userName }}</v-list-item-title>
              <v-list-item-subtitle>{{ userEmail }}</v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ empresaSelected ? empresaSelected.nombre : null }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="hasPermission('rol_edit')"
            @click="showRolesDialog()"
          >
            <v-list-item-content>
              <v-list-item-title>Roles y habilidades</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('config_edit')" to="crud">
            <v-list-item-content>
              <v-list-item-title>Configuración</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="logout()">
            <v-list-item-title class="red--text">
              Salir
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-content class="primary lighten-5">
      <v-container fluid class="pa-0">
        <v-sheet
          v-if="isLoggedIn && empresas.length > 1 && isMobile"
          flat
          tile
          dark
          color=" primary darken-2 pa-1"
        >
          <v-select
            v-model="empresaSelected"
            :items="empresas"
            item-text="nombre"
            placeholder="Empresa"
            return-object
            hide-details
            single-line
            outlined
            tile
            dense
            :loading="empresasLoading"
            label="label"
            @input="setEmpresaSelected"
          />
        </v-sheet>

        <router-view />
      </v-container>
    </v-content>

    <roles-dialog :key="keyRolesDialog" v-model="rolesDialogShowed" />
  </v-app>
</template>

<script>
import _ from "lodash";
import rolesDialog from "./components/rolesDialog";
import campoModel from "@/models/campoModel";

export default {
  name: "App",
  components: {
    rolesDialog
  },
  data() {
    return {
      drawer: false,
      rolesDialogShowed: false,
      keyRolesDialog: 0,
      mini: true,
      searchEmpresaInput: "",
      searchEmpresaLoading: false,
      empresasLoading: false,
      campos: [],
      items: [
        { title: "Tarjas", icon: "assignment_ind", to: "/tarjas" },
        { title: "Remuneraciones", icon: "bug_report", to: "/remuneraciones" },
        { title: "Analisis", icon: "bug_report", to: "/analisis" },
        { title: "Analisis Presupuestos", icon: "bug_report", to: "/analisisPresupuesto", ability:"developer" },
      ],
      itemSelected: null
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    abilities() {
      return this.$store.getters.abilities;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    withTabs() {
      if (this.$route.meta.withTabs) {
        return this.$route.meta.withTabs;
      }
      return true;
    },
    isTest() {
      return this.$store.getters.isTest;
    },
    userName() {
      return this.$store.getters.userName;
    },
    userEmail() {
      return this.$store.getters.userEmail;
    },
    empresas() {
      return this.$store.getters.empresas;
    },
    empresaSelected() {
      return this.$store.getters.empresaSelected;
    },
    snackbarText() {
      return this.$store.getters.snackbarText;
    },
    showedSnackBar() {
      return this.$store.getters.showedSnackBar;
    },
    queryString() {
      return this.$route.query;
    }
  },
  watch: {
    $route() {
      var itemRoute = _.find(this.items, { to: this.$route.name });
      this.itemSelected = itemRoute || _.first(this.items);
    },
    empresaSelected(){
      if(this.empresaSelected && this.empresaSelected.id){
        this.getCampos(this.empresaSelected.id);
      }
    }
  },
  mounted() {
    var self = this;
    this._routerRoot.$on("toggleDrawer", () => {
      self.toggleDrawer();
    });
  },
  created() {
    var itemRoute = _.find(this.items, { to: this.$route.name });
    this.itemSelected = itemRoute || _.first(this.items);
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },

    hasPermission(ability) {
      return ability ? _.find(this.abilities, { name: ability }) : true;
    },

    getCampos(empresa_id){
      return campoModel.all({
          params: { empresa_id }
        }).then(res => {
          this.campos = res.data.data;
          return res;
        }, resError => console.error(resError))
    },

    toggleDrawer(isVisible) {
      isVisible = isVisible !== undefined ? isVisible : !this.drawer;
      this.drawer = isVisible;
    },

    setEmpresaSelected(empresa) {
      this.$store.commit("set_empresa_selected", empresa);
    },

    hideSnackBar() {
      this.$store.commit("hideSnackBar");
    },

    changeSnackbar() {
      this.$store.commit("hideSnackBar");
    },
    showRolesDialog() {
      this.rolesDialogShowed = true;
      this.keyRolesDialog++;
    }
  }
};
</script>
<style lang="scss">
//GLOBAL

.fill-height-screen {
  height: calc(100vh - 65px) !important;
  overflow-y: scroll;
  position: relative;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

html {
  overflow-y: auto;
}

.v-toolbar__items > div > .v-btn {
  border-radius: 0;
  height: 100% !important;
  max-height: none;
}

.pointer {
  cursor: pointer;
}

.active-tab {
  background-color: white !important;
  span {
    color: rgba(13, 71, 161, 1);
  }
}
.v-app-bar {
  .v-btn,
  .v-btn span {
    transition: 0.2s all ease !important;
  }
}

.p-relative {
  position: relative;
}
.p-absolute {
  position: absolute;
  &.top {
    top: 0;
  }
  &.right {
    right: 0;
  }
  &.bottom {
    bottom: 0;
  }
  &.left {
    left: 0;
  }
}

//---buttons
.v-btn {
  transition: 0.5s all ease;
  &.rotate {
    transform: rotate(180deg);
  }
}

.v-icon {
  &.rotate {
    transform: rotate(180deg);
  }
}

.truncate {
  width: 100%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.link span {
  text-decoration: underline;
  cursor: pointer;
}


.v-select.has-append-btn {
  .v-input__control {
    [role="button"] {
      border-radius: 4px 0px 0px 4px;
    }
  }

  .v-input__append-outer {
    margin: 0 !important;
    height: inherit;
    .v-btn:not(.v-btn--round) {
      border-left: none;
      border-radius: 0px 4px 4px 0px;
      margin-right: 8px;
      height: 40px;
      color: rgba(0, 0, 0, 0.54);
      border-color: rgba(0, 0, 0, 0.38);
      min-width: 48px;
      padding: 0 8px;
      &:hover {
        border-color: rgba(0, 0, 0, 0.86);
        color: rgba(0, 0, 0, 0.86);
      }
    }
  }
}

// print
@media print {
  .v-application main.v-content.primary.lighten-5 {
    background: white !important;
    background-color: white !important;
  }
  #principal-header {
    display: none;
    & + .v-content {
      padding: 0 !important;
    }
  }
}

@page {
  orphans: 10;
}
</style>
